import { useEffect, useState } from "react";
import {
  BUTTON_CONNECT_ACCOUNT,
  BUTTON_CONNECT_GOOGLE,
} from "../../i18n/keysTranslations";
import {
  BUTTON_GOOGLE_ACTION_ID,
  GOOGLE,
  MODE_BACK_DROP_CONNECT,
} from "../../utils/constants";
import Avatar from "@mui/material/Avatar";
import { logoPlatform } from "../../utils/string";
import { useTranslationApp } from "../../lib/i18next";
// import { getNameBusinessTheme } from "../../actions/getters";
import { useDispatchApp, useSelectorApp } from "../../lib/redux";
import { createPortal } from "react-dom";
import BackDropLoader from "../Loaders/BackDropLoader";
import IconButton from "./IconButton";
import { ConfirmAlert } from "../Alerts/Alerts";
import ConnectionProgressModal from "../Containers/ConnectionProgressModal";
import Loader from "../Loaders/Loader";
import AddIcon from "@mui/icons-material/Add";
import {
  startConnectGoogleAds,
  startGetTokenGoogleAds,
} from "../../actions/user";
import { startAfterPlatformConnected } from "../../actions/agencyAccountLinking";
import { showPlatformConnectedAlert } from "../../utils/showPlatformConnectedAlert";
import Button from "./Button";

const ButtonGoogleAction = ({
  id = BUTTON_GOOGLE_ACTION_ID,
  text = BUTTON_CONNECT_GOOGLE,
  disabled = false,
  prevBlockClick = false,
  onPrevBlockClick = () => {},
  onClick = () => {},
  onCallbackOpenPopup = () => {},
  sx = {},
  logo = GOOGLE,
  showLogo = true,
  type = "button",
  mode = "verify",
  requirePlatformConnection = true,
  icon = <AddIcon />,
  disableRipple = false,
  showButtonIcon = false,
  doTranslation = true,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [externalPopup, setExternalPopup] = useState(null);
  const [modeBackDrop, setModeBackDrop] = useState();

  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const integrations = useSelectorApp((state) => state?.user?.integrations);
  const googleIntegrations = integrations?.google || {};
  const isGoogleConnected = Object.values(googleIntegrations).some(
    (integration) => integration.isActive
  );

  const onConnectAccount = async () => {
    const result = await ConfirmAlert({
      icon: false,
      confirmButtonText: t(BUTTON_CONNECT_ACCOUNT),
      html: <ConnectionProgressModal platform={GOOGLE} />,
      width: "60vh",
    });

    if (!result.isConfirmed) return;

    setModeBackDrop(MODE_BACK_DROP_CONNECT.GET_POPUP);
    dispatch(
      startConnectGoogleAds({
        onChangeLoading: (loading) => {
          setIsLoading(loading);
          setOpenBackDrop(loading);
          if (!loading) {
            onCallbackOpenPopup();
          }
        },
        onChangePopupReference: (popup) => setExternalPopup(popup),
      })
    );
  };

  const onGetTokenGoogleAds = async ({ authCode, state }) => {
    setModeBackDrop(MODE_BACK_DROP_CONNECT.GET_INFORMATION);
    setOpenBackDrop(true);
    const response = await dispatch(
      startGetTokenGoogleAds({ authCode, state, withAuth: true })
    );
    setOpenBackDrop(false);

    if (response.ok) {
      await showPlatformConnectedAlert({ t });
      await dispatch(
        startAfterPlatformConnected({
          platform: GOOGLE,
          integration: response.data,
        })
      );
      await onClick();
    }
  };

  useEffect(() => {
    if (!externalPopup) {
      return;
    }

    const timer = setInterval(() => {
      if (!externalPopup || externalPopup.closed) {
        clearInterval(timer);
        setExternalPopup(null);
        return;
      }

      try {
        const currentUrl = externalPopup.location.href;
        if (!currentUrl) {
          return;
        }
        const searchParams = new URL(currentUrl).searchParams;
        const authCode = searchParams.get("code");
        const state = searchParams.get("state");

        if (authCode && state) {
          externalPopup.close();
          setExternalPopup(null);
          clearInterval(timer);

          onGetTokenGoogleAds({
            authCode,
            state,
          });
        }
      } catch {
        if (externalPopup.closed) {
          clearInterval(timer);
          setExternalPopup(null);
        }
      }
    }, 500);

    return () => {
      timer && clearInterval(timer);
    };
    // eslint-disable-next-line
  }, [externalPopup]);

  if (type === "icon") {
    return (
      <>
        {openBackDrop &&
          createPortal(
            <BackDropLoader
              open={openBackDrop}
              platform={GOOGLE}
              from={modeBackDrop}
            />,
            document.body
          )}
        <IconButton
          id={id}
          disableRipple={disableRipple}
          sx={{ ...sx }}
          onClick={async (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (prevBlockClick) {
              onPrevBlockClick();
              return;
            }

            if (
              requirePlatformConnection &&
              ((!isGoogleConnected && mode === "verify") || mode === "add")
            ) {
              await onConnectAccount();
              return;
            }

            setIsLoading(true);
            onClick();
            setIsLoading(false);
          }}
        >
          {isLoading ? <Loader hasMarginTop={false} size={20} /> : icon}
        </IconButton>
      </>
    );
  }
  return (
    <>
      {openBackDrop &&
        createPortal(
          <BackDropLoader
            open={openBackDrop}
            platform={GOOGLE}
            from={modeBackDrop}
          />,
          document.body
        )}
      <Button
        id={id}
        disabled={disabled}
        loading={isLoading}
        color="secondary"
        sx={{
          ...sx,
        }}
        onClick={async (e) => {
          e.preventDefault();
          if (prevBlockClick) {
            onPrevBlockClick();
            return;
          }

          if (
            requirePlatformConnection &&
            ((!isGoogleConnected && mode === "verify") || mode === "add")
          ) {
            await onConnectAccount();
            return;
          }

          setIsLoading(true);
          await onClick();
          setIsLoading(false);
        }}
      >
        {showButtonIcon && icon}
        {showLogo && (
          <Avatar
            src={logoPlatform(logo)}
            variant="square"
            sx={{
              width: "20px",
              height: "20px",
              mr: 1,
              ".MuiAvatar-img": {
                objectFit: "contain",
              },
            }}
          />
        )}
        {doTranslation ? t(text) : text}
      </Button>
    </>
  );
};

export default ButtonGoogleAction;
